<template>
  <div class="section-grid">
    <div>
      <FactorScoreRollUp
        :data-loaded="dataLoaded"
        title="Business Profile"
        remote-key="business_profile"
        :issuer="issuer"
        :model-data="modelData"
        :template="templateData"
      ></FactorScoreRollUp>
    </div>
    <div>
      <CorpFinancials :issuer="issuer"></CorpFinancials>
    </div>
    <div>
      <FactorScoreRollUp
        :data-loaded="dataLoaded"
        title="Management Strategy"
        remote-key="mgmt_strategy"
        :issuer="issuer"
        :model-data="modelData"
        :template="templateData"
      ></FactorScoreRollUp>
    </div>
    <div>
      <FactorScoreRollUp
        :data-loaded="dataLoaded"
        title="Sovereign"
        remote-key="sovereign"
        :issuer="issuer"
        :model-data="modelData"
        :template="templateData"
      ></FactorScoreRollUp>
    </div>
    <div>
      <CorpDebtStructure :issuer="issuer"></CorpDebtStructure>
    </div>
    <div>
      <CorpDebtStructureFunding :issuer="issuer"></CorpDebtStructureFunding>
    </div>
  </div>
</template>

<script>
import FactorScoreRollUp from "@/components/common/FactorScoreRollUp.vue"
import CorpFinancials from "@/components/CorpFinancials.vue"
import CorpDebtStructure from "@/components/CorpDebtStructure.vue"
import CorpDebtStructureFunding from "@/components/CorpDebtStructureFunding.vue"
import CorpApi from "@/apis/corpApi"

export default {
  components: {
    FactorScoreRollUp,
    CorpFinancials,
    CorpDebtStructure,
    CorpDebtStructureFunding
  },
  props: {
    issuer: { type: String, required: true }
  },
  data() {
    return {
      modelData: null,
      summaryData: null,
      templateData: null,
      dataLoaded: false
    }
  },
  async mounted() {
    const api = new CorpApi()

    const [summaryData, modelData] = await Promise.all([
      api.loadIssuerInfo(this.issuer),
      api.loadCrmModelResult(this.issuer)
    ])

    const templateData = await api.loadCrmModelTemplate(summaryData.is_financial)
    this.modelData = modelData
    this.summaryData = summaryData
    this.templateData = templateData
    this.dataLoaded = true
  }
}
</script>

<style scoped>
.section-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(540px, 1fr));
  gap: 0 16px;
  grid-auto-flow: row;
  max-width: 1880px;
}
</style>
